import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import AutoSizer, { Size } from 'react-virtualized-auto-sizer';
import isEqual from 'lodash.isequal';
// Types
import { AppState } from 'services/types';
import {
    VirtualizedTableColumnKey,
    VirtualizedTableColumnWidth,
    VirtualizedTableColumns,
    VirtualizedTableItem,
    VirtualizedTableItemKey
} from 'services/virtualizedTable/types';
// Global Actions
import { setColumnWidth } from 'services/columnWidths/actions';
// Global Components
import VirtualizedTable from 'components/VirtualizedTable';
import { ROW_HEIGHT } from 'components/VirtualizedTable/constants';
import { DOCUMENT_SET_LOAD_NAMESPACE } from 'services/documentSets/constants';
import { updateQueryString } from 'services/router/actions';
import {
    selectJobAssessmentsTableColumns,
    makeSelectJobAssessmentItems
} from './selectors';
import './styles.scss';
import { VIEW_JOB_ASSESMANT_MODAL } from '../JobAssessmentsViewModal/constants';

interface OwnProps {
    tableId: string;
    documentSetId: number;
}
interface ConnectedProps {
    items: VirtualizedTableItem[];
    columns: VirtualizedTableColumns;
}
interface DispatchProps {
    setColumnWidth: typeof setColumnWidth;
    updateQueryString: typeof updateQueryString;
}

type Props = OwnProps & ConnectedProps & DispatchProps;
const MAX_ROWS = 10;
export class JobAssessmentsVirtualizedTable extends React.Component<Props> {
    shouldComponentUpdate(nextProps: Props): boolean {
        return !isEqual(this.props, nextProps);
    }

    handleColumnResized = (
        columnKey: VirtualizedTableColumnKey,
        columnWidth: VirtualizedTableColumnWidth
    ): void => {
        const { tableId, ...props } = this.props;
        props.setColumnWidth(tableId, columnKey, columnWidth);
    };

    handleOnExpand = (uuid: VirtualizedTableItemKey): void => {
        const { ...props } = this.props;

        props.updateQueryString({
            [VIEW_JOB_ASSESMANT_MODAL]: true,
            uuid
        });
    };

    renderVirtualizedTable = ({ height, width }: Size): React.ReactElement => {
        const { tableId, items, columns } = this.props;

        return (
            <VirtualizedTable
                id={tableId}
                height={height}
                width={width}
                columns={columns}
                items={items}
                onExpand={this.handleOnExpand}
                onColumnResized={this.handleColumnResized}
                labelPlural="Assesments"
                loadNamespace={DOCUMENT_SET_LOAD_NAMESPACE}
            />
        );
    };

    render(): React.ReactElement {
        const { items } = this.props;
        const height =
            ROW_HEIGHT * Math.min(items.length || 2, MAX_ROWS) + ROW_HEIGHT; // + header height

        return (
            <div
                className="job-assessments-table"
                style={{ height: `${height}px` }}
            >
                <AutoSizer>
                    {(size: Size): React.ReactElement =>
                        this.renderVirtualizedTable(size)
                    }
                </AutoSizer>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    items: makeSelectJobAssessmentItems(),
    columns: selectJobAssessmentsTableColumns
});

export default connect(mapStateToProps, {
    setColumnWidth,
    updateQueryString
})(JobAssessmentsVirtualizedTable);
